import React from 'react';

// import default view
import { timeField as TimeFieldView } from './TimeField.view';


/**
 * @type {function}
 * @desc A Higher-Order-Component to enhance functionality of `Component`
 * @param {object} Component - A React component
 * @example
 * import { timeField, TimeField } from 'modules/TimeField';
 *
 * // create a component
 * const ComponentWithHOC = timeField( CustomView );
 */
export class TimeField extends React.Component {
        constructor( props ) {
            super( props );

        }

        render() {
            return (
                <TimeFieldView { ...this.props } />
            );
        }
}

// set display name
TimeField.displayName = 'TimeField';
    
// default props
TimeField.defaultProps = {
    showLabel: true
};

// prop types
TimeField.propTypes = {};
